import { Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import styles from "./ContentWrapper.module.css"

type ContentWrapper = {
    title?: string,
    description?: string,
    className?: string
}

export default function ContentWrapper({children, title="", description="", className}: PropsWithChildren & ContentWrapper){
    return (
        <div className={`${styles.page} ${className ?? ""}`}>
            {title && <div className={styles.text}>
                <Typography className={styles.title}>
                    {title}
                </Typography>
                <Typography className={styles.description}>
                    {description}
                </Typography>
            </div>}
            {children}
        </div>
    )
}